import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../contexts/LanguageContext';
import { langToSlug } from '../hooks/useLocalePath';
import { renderT } from '../i18n/renderT';
import DifferentialsList from '../components/features/DifferentialsList';

const Manifesto: React.FC = () => {
    useScrollReveal();
    const { language, t } = useLanguage();
    const lp = (path: string) => `/${langToSlug(language)}${path}`;

    return (
        <main>
            <SEOHead pageId="manifesto" />
            {/* ── Hero ── */}
            <section className="mf-hero" id="manifesto-hero">
                <div className="container">
                    <div className="section-label reveal">{t('mf.heroLabel')}</div>
                    <h1 className="mf-hero-headline reveal">{renderT(t('mf.heroHeadline'))}</h1>
                    <p className="mf-hero-sub reveal reveal-d1">
                        {t('mf.heroSub')}
                    </p>
                    <div className="mf-hero-line reveal reveal-d2" />
                </div>
            </section>

            {/* ── Long-form editorial ── */}
            <section className="mf-body" id="manifesto-body">
                <div className="container">
                    <div className="mf-article">

                        <h2 className="reveal">{renderT(t('mf.h1'))}</h2>
                        <p className="reveal">{t('mf.p1a')}</p>
                        <p className="reveal">{t('mf.p1b')}</p>
                        <p className="reveal">{t('mf.p1c')}</p>

                        <div className="mf-pull-quote reveal">
                            {renderT(t('mf.quote1'))}
                        </div>

                        <h2 className="reveal">{renderT(t('mf.h2'))}</h2>
                        <p className="reveal">{t('mf.p2a')}</p>
                        <p className="reveal">{t('mf.p2b')}</p>
                        <p className="reveal">{t('mf.p2c')}</p>

                        <div className="mf-divider reveal" />

                        <h2 className="reveal">{renderT(t('mf.h3'))}</h2>
                        <p className="reveal">{t('mf.p3a')}</p>
                        <p className="reveal">{t('mf.p3b')}</p>
                        <p className="reveal">{t('mf.p3c')}</p>

                        <div className="mf-pull-quote reveal">
                            {renderT(t('mf.quote2'))}
                        </div>

                        <h2 className="reveal">{renderT(t('mf.h4'))}</h2>
                        <p className="reveal">{t('mf.p4a')}</p>
                        <p className="reveal">{t('mf.p4b')}</p>
                        <p className="reveal">{t('mf.p4c')}</p>

                        <div className="mf-divider reveal" />

                        <h2 className="reveal">{renderT(t('mf.h5'))}</h2>
                        <p className="reveal">{t('mf.p5a')}</p>
                        <p className="reveal">{t('mf.p5b')}</p>
                        <p className="reveal">{t('mf.p5c')}</p>

                    </div>
                </div>
            </section>

            {/* ── 9 Differentials ── */}
            <DifferentialsList />

            {/* ── CTA Strip ── */}
            <section className="mf-cta" id="manifesto-cta">
                <div className="container">
                    <div className="section-label reveal" style={{ justifyContent: 'center' }}>{t('cta.nextStep')}</div>
                    <h2 className="mf-cta-headline reveal">
                        {renderT(t('cta.readyHeadline'))}
                    </h2>
                    <p className="mf-cta-sub reveal reveal-d1">
                        {t('cta.readySub')}
                    </p>
                    <div className="mf-cta-btns reveal reveal-d2">
                        <Link to={lp('/contact#contact-form')} className="btn-primary">
                            {t('cta.startDiscovery')}
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                        <Link to={lp('/services')} className="btn-secondary">{t('cta.exploreMethodology')}</Link>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Manifesto;
